import { PDxListItem } from "src/app/core/PDxListItem.model";
import { PDxUserPermission } from "src/app/core/PDxUserPermission.enum";
import { UserInformation } from "src/app/core/user-properties/user-information.model";

export class EntityAssignmentInformation {
    constructor() {
        this.hierarchy = [];
        this.passToChildren = true;
        this.permissions = [];
        this.user = new UserInformation();
    }

    entityId: string;
    userId: string;
    hierarchy: PDxListItem<string>[];
    passToChildren: boolean;
    permissions: PDxUserPermission[];
    user: UserInformation;

    secondaryEntities: SecondaryEntityInformation[] = [];
}

export class SecondaryEntityInformation {
    constructor() {
        this.passToChildren = true;
        this.permissionDisplayList = [];
        this.permissions = [];
    }
    entityId: string;
    entityName: string;
    passToChildren: boolean;
    fullAddress: string;
    permissionDisplayList: string[];
    permissions: PDxUserPermission[];
}
